import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createConfig, http, WagmiProvider } from "wagmi";
import {
  mainnet,
  polygon,
  arbitrum,
  optimism,
  base,
  sepolia,
} from "wagmi/chains";
import { injected, walletConnect, coinbaseWallet } from "@wagmi/connectors";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// ✅ Create Wagmi config with WalletConnect v3
const config = createConfig({
  chains: [mainnet, polygon, arbitrum, optimism, base, sepolia],
  connectors: [
    injected({ target: 'metaMask' }),
    injected({ target: 'bestWallet' }),
    walletConnect({ 
      projectId: "bb6f224480e3e1bd061eba879fe02cef",
      showQrModal: true,
      metadata: {
        name: "AIFlow",
        description: "AI-Powered Insights for Smart Crypto Choices",
        url: typeof window !== 'undefined' ? window.location.origin : '',
        icons: typeof window !== 'undefined' ? [`${window.location.origin}/logo192.png`] : [],
      },
    }),
    coinbaseWallet({ appName: "AIFlow" }),
  ],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
    [base.id]: http(),
    [sepolia.id]: http(),
  },
  ssr: false,
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </WagmiProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
